import ProductViewControlController from './view-control';

export default class ScansScanProductVerifiedReportsController extends ProductViewControlController {}
